import ExtensionEventType from 'owa-service/lib/contract/ExtensionEventType';
import { ExtensibilityModeEnum } from 'owa-addins-types';
import { getExtensibilityState, IAddinCommand } from 'owa-addins-store';

export default function getExtensionEventByType(type: ExtensionEventType): IAddinCommand[] {
    const enabledAddinCommands = getExtensibilityState().EnabledAddinCommands;
    const eventAddins = enabledAddinCommands.getExtensionPoint(
        ExtensibilityModeEnum.TrapOnSendEvent
    );
    return eventAddins.map(addin => {
        return addin.AddinCommands.get(type.toString());
    });
}
